// extracted by mini-css-extract-plugin
export var modalBox = "z_vm";
export var backdrop = "z_vn";